import React from 'react';
import QRETable from './qre_table/components/QRETable';
import { QRE_CLASSIFICATION } from '../../../constants/qre_constants';

const ContractTab = () => {
  return <QRETable qreType={QRE_CLASSIFICATION.CONTRACT} />;
};

export default ContractTab;
